import React from 'react'
import { UseDocumentTestResultType } from './documentTestResultType'
import { useForm } from 'react-final-form'
import useLookupClient from '../../../../services/lookupClient/useLookupClient'
import { generatePath, useHistory, useLocation } from 'react-router-dom'
import { RoutePath } from '../../../../router/routesConfig'
import { encryptionAES } from '../../../../utilities/encryption'
import useManageProjectStore from '../../../../stores/manageProject/useManageProjectStore'
import useHistoryAction from '../../../../stores/history/useHistoryAction'
import useHistoryStore from '../../../../stores/history/useHistoryStore'

const useDocumentTestResult = (props: UseDocumentTestResultType) => {
    const { onChangeDocCompletely, onSubmitEdit, onClickModeEdit } = props
    const [selectedCompletely, setSelectedCompletely] = React.useState<string>()
    const form = useForm()
    const lookupClient = useLookupClient()
    const history = useHistory()
    const { projectData } = useManageProjectStore()
    const { state } = useLocation()
    const historyStoreAction = useHistoryAction()
    const historyStore = useHistoryStore()
    
    React.useEffect(() => {
        if (form.getFieldState('isCompletelyDoc')?.initial) {
            setSelectedCompletely(form.getFieldState('isCompletelyDoc')?.initial)
        }
    }, [form.getFieldState('isCompletelyDoc')?.initial])

    const handleChangeRadio = (val: string) => {
        setSelectedCompletely(val)
        if (onChangeDocCompletely) {
            onChangeDocCompletely(val)
        }
    }

    const navigateToResultHistory = (event: any) => {
        event.stopPropagation()
        const paramData = {
            projectID: projectData?.projectID,
            submittedID: projectData?.submittedID,
            submittedTypeID: projectData?.submitTypeInfo?.value
        }
        const encryptedProjectData = encryptionAES(JSON.stringify(paramData))

        const path = generatePath(RoutePath.documentVerifyHistory, {
            projectData: encryptedProjectData
        })
        history.push({
            pathname: path,
            state: state
        })
    }

    const submitAndUpdateHistoryDisplay = async () => {
        onSubmitEdit && onSubmitEdit()
        if (projectData?.submittedID) {
            await historyStoreAction.updateDisplayHistory(projectData?.submittedID)
        }
    }

    return {
        selectedCompletely,
        documentLut: lookupClient.getDocumentResult(),
        displayHistory: historyStore.displayVerifyDocHistory,
        onChangeRadio: handleChangeRadio,
        navigateToResultHistory,
        onSubmitEdit: submitAndUpdateHistoryDisplay,
        onClickModeEdit
    }
}

export default useDocumentTestResult
